import { GameVars } from "./GameVars";
import "phaser";
import { Game } from "./Game";
import { BootScene } from "./scenes/BootScene";
import { GameConstants } from "./GameConstants";
import { PreloadScene } from "./scenes/PreloadScene";
import { SplashScene } from "./scenes/splash/SplashScene";
import { RoomScene } from "./scenes/room/RoomScene";
import { AnimationScene } from "./scenes/animation-test/AnimationScene";
import { BananaScene } from "./scenes/banana-test/BananaScene";
import { HiLoScene } from "./scenes/hi-lo/HiLoScene";
import { GameManager } from "./managers/GameManager";

let game: Game;

window.onload = () => {

    const gameConfig = {
        type: Phaser.AUTO,
        backgroundColor: "#001430",
        scale: {
            mode: Phaser.Scale.FIT,
            parent: "content",
            width: GameConstants.GAME_WIDTH,
            height: GameConstants.GAME_HEIGHT
        },
        plugins: {
            scene: [
                {
                    key: "SpineWebGLPlugin",
                    plugin: SpineWebGLPlugin,
                    start: true,
                    sceneKey: "spine"
                }
            ]
        },
        scene: [BootScene, PreloadScene, SplashScene, RoomScene, AnimationScene, BananaScene, HiLoScene]
    };

    game = new Game(gameConfig);
    window.focus();
    resize();

    window.addEventListener("resize", resize, false);
    window.addEventListener("orientationchange", checkOriention, false);
};

function resize(): void {

    const canvas = document.querySelector("canvas");
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const windowRatio = windowWidth / windowHeight;

    const gameWidth: any = game.config.width;
    const gameHeight: any = game.config.height;

    const gameRatio = gameWidth / gameHeight;
    
    if (windowRatio < gameRatio) {
        canvas.style.width = windowWidth + "px";
        canvas.style.height = (windowWidth / gameRatio) + "px";
    } else {
        canvas.style.width = (windowHeight * gameRatio) + "px";
        canvas.style.height = windowHeight + "px";
    }
}

function checkOriention(): void {

    if (Game.currentInstance.device.os.desktop) {
        return;
    }

    GameVars.currentScene.time.addEvent({delay: 200, callback: () => {

        const w = window.innerWidth;
        const h = window.innerHeight;

        if (h > w) {
            document.getElementById("orientation").style.display = "block";
            document.getElementById("content").style.display = "none"; 
        } else {
            document.getElementById("orientation").style.display = "none";
            document.getElementById("content").style.display = "block";

            if (!GameVars.gameLoaded) {

                GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
                GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);

                GameManager.onGameAssetsLoaded();
                PreloadScene.currentInstance.scene.setVisible(false);
                GameVars.gameLoaded = true;
            }
        }
    }, callbackScope: GameVars.currentScene});
}
